import { createAsyncThunk } from '@reduxjs/toolkit';
import { ConfigsApi } from './ConfigsApi';

export const fetchAllConfigs = createAsyncThunk('configs/fetchAllConfigs', async () => {
  const response = await ConfigsApi.fetchAllConfigs();
  return response.data;
});
